export default __webpack_public_path__ + "static/media/n2.efc2dc05.jpeg";